import { useState } from 'react';
import { useAuth } from './AuthContext.jsx';

/**
 * "You are viewing Orbit as someone else", plus the way out.
 *
 * Rendered in the top bar by both shells — OrbitModuleHeader for every module, and HubPage,
 * which hand-rolls its own nav. Mounted in both rather than at the app root because the top bar
 * is the one element present on every screen, and an impersonation you can navigate away from
 * the exit of is an impersonation people forget they are in.
 *
 * Returns null when not impersonating, so both call sites can mount it unconditionally.
 */
export default function ImpersonationBadge() {
  const { user, impersonating, impersonatorName, stopImpersonating } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!impersonating) return null;

  async function exit() {
    setBusy(true);
    try {
      await stopImpersonating();
    } finally {
      // No setBusy(false) on success — stopImpersonating navigates, and clearing the flag
      // first would flash an enabled button on a page that is already going away.
      setBusy(false);
    }
  }

  return (
    <div className="o-imp" role="status">
      <span className="o-imp-txt">
        Viewing as <b>{user?.fullName || user?.username}</b>
      </span>
      <button onClick={exit} disabled={busy}>
        {busy ? 'Exiting…' : `Exit${impersonatorName ? ` to ${impersonatorName}` : ''}`}
      </button>
    </div>
  );
}
